export const selectNavStyle = ({ settings }) => settings.navStyle
export const selectTopBarTitle = ({ settings }) => settings.topBarTitle
